import type { Widget, WidgetTemplateListItem } from "../types";
import type { UserRole } from "@/modules/membership";
import WidgetListItem from "./widget-list-item";

export interface WidgetListProps {
	widgets: Widget[];
	templates?: WidgetTemplateListItem[] | null;
	onDelete?: (id: string) => void;
	onEdit?: (id: string) => void;
	onStatusChange?: (id: string, status: string) => void;
	userRole?: UserRole | null;
}

export default function WidgetList({ widgets, templates, onDelete, onEdit, onStatusChange, userRole }: WidgetListProps) {
	return (
		<div className="space-y-2">
			{widgets.map((widget) => (
				<WidgetListItem key={widget.id} widget={widget} templates={templates} onDelete={onDelete} onEdit={onEdit} onStatusChange={onStatusChange} userRole={userRole} />
			))}
		</div>
	);
}
